module.exports = __webpack_public_path__ + "img/bio-photo-02.79ec2a7d.jpg";